import { FC } from "react"
import { FormSearchLeftProps } from "./models"
import { Styled } from "./styled"

const { StyledFormSearchLeft } = Styled

export const FormSearchLeft: FC<FormSearchLeftProps> = ({
  children,
  ...res
}) => (
  <StyledFormSearchLeft className="form-search-left" {...res}>
    {children}
  </StyledFormSearchLeft>
)
